import {EAudienceGroupState, EContentType} from 'src/constants';

import {EMessageMatcherButtonTypes} from '../MessageMatchers/definitions';
import {EFormStep, EStatisticsCount, EStatus} from './definitions';

export default {
  createBroadcast: 'рассылку',
  actions: {
    cancelBroadcast: 'Отменить рассылку',
    returnToDrafts: 'Вернуть в черновики',
  },
  details: {
    actions: 'Действия с рассылкой',
    statusAt: {
      [EStatus.SCHEDULED]: 'Последнее обновление в {{date}}',
      [EStatus.RUNNING]: 'Стартовала в {{date}}',
      [EStatus.COMPLETED]: 'Выполнена в {{date}}',
      [EStatus.CANCELLED]: 'Отменена в {{date}}',
      [EStatus.TRIGGERED]: 'Стартовала в {{date}}',
      [EStatus.CANCELING]: 'Отменена в {{date}}',
    },
    nameLabel: 'Название рассылки',
    initiatorLabel: 'Инициатор рассылки',
    statisticsTitle: 'Статистика рассылки',
    stagesStatisticsTitle: 'Статистика по шагам каскада',
    clicksStatisticsTitle: 'Статистика переходов по кнопкам-ссылкам',
    requestedAt: 'Данные на {{date}}',
    statistics: {
      [EStatisticsCount.totalCount]: 'Отправленные сообщения',
      [EStatisticsCount.deliveredCount]: 'Доставленные сообщения',
      [EStatisticsCount.readCount]: 'Прочитанные сообщения',
      [EStatisticsCount.clickedCount]: 'Перешли по кнопке-ссылке в сообщении',
      [EStatisticsCount.undeliveredCount]: 'Неполученные сообщения',
    },
    th: {
      name: 'Шаг каскада/канал',
      sentCount: 'Отправлено в канале',
      deliveredCount: 'Получили в канале',
      clickedCount: 'Перешли по кнопке-ссылке',
      clickedPercentCount: '% от аудитории рассылки',
      readCount: 'Прочитали в канале',
      undeliveredCount: 'Не получили (просрочено)',
      insideChannel: 'В сообщении канала',
      buttonCount: 'Кнопка {{count}}: <0>{{name}}</0>',
      button: 'Кнопка: <0>{{name}}</0>',
    },
    report: 'Отчет по сообщениям',
  },
  allEmpty: {
    title: 'Terra incognita! Неизведанная земля!',
    subtitle:
      'Сюда еще никто не заходил чтобы создать рассылку. Всего пару подготовительных шагов, и вы будете первым!',
    listTitle: 'Что нужно для начала?',
    listItem1: 'Зарегистрировать на платформе хотя бы один <0>канал коммуникации</0>',
    listItem2:
      'Если канал работает только с шаблонами, зарегистрировать хотя бы один <0>шаблон для канала</0>',
    messageMatchersButton: 'В шаблоны',
    channelsButton: 'В каналы',
  },
  empty: {
    title: 'Вы первопроходец!',
    subtitle: 'Здесь пока еще нет рассылок, но вы легко это исправите!',
    listTitle: 'Проверим, что у вас уже есть все необходимое для начала:',
    listItem1: 'Хотя бы один зарегистрированный <0>канал коммуникации</0>',
    listItem2: 'Если канал работает только с шаблонами, для него есть хотя бы один <0>шаблон</0>',
    createButton: 'Создать рассылку',
  },
  th: {
    startPlannedAt: 'Дата запуска',
    name: 'Название рассылки',
    status: 'Статус рассылки',
    audience: 'Аудитория рассылки',
    receivedMessagesNumber: 'Получили сообщения',
    openedMessagesNumber: 'Открыли сообщения',
    notReceivedMessagesNumber: 'Не получили',
  },
  td: {
    cascade: 'Каскад: {{name}}',
  },
  status: {
    [EStatus.DRAFT]: 'Черновик',
    [EStatus.SCHEDULED]: 'Запланирована',
    [EStatus.TRIGGERED]: 'Запланирована',
    [EStatus.RUNNING]: 'Выполняется',
    [EStatus.CANCELING]: 'Отменяется',
    [EStatus.COMPLETED]: 'Завершена',
    [EStatus.CANCELLED]: 'Отменена',
  },
  confirm: {
    cancelTitle: 'Хотите отменить рассылку?',
    cancelBody:
      'Если вы сейчас нажмете "да", то выбранная вами рассылка будет остановлена, и запустить ее заново вы не сможете, придется создавать заново',
    delete: 'Вы уверены, что хотите удалить рассылку "{{name}}" без возможности восстановления?',
  },
  steps: {
    [EFormStep.SETTINGS]: 'Настройки рассылки',
    [EFormStep.AUDIENCE]: 'Аудитория рассылки',
    [EFormStep.CONTENT]: 'Содержание рассылки',
    [EFormStep.CHECK]: 'Проверка рассылки',
  },
  messageSpeedOptions: {
    perSecond_one: '{{count}} сообщение в секунду',
    perSecond_few: '{{count}} сообщения в секунду',
    perSecond_many: '{{count}} сообщений в секунду',
    defaultPrefix: 'По умолчанию - ',
  },
  settingsForm: {
    name: 'Название рассылки',
    nameHint: 'Название будет использоваться в списке рассылок и в отчете по сообщениям',
    startPlannedAt: 'Дата и время отправки рассылки',
    startNow: 'Отправить сразу',
    startPlannedAtCustom: 'Задать дату и время',
    timeZone: 'Часовой пояс при отправке сообщений',
    timeZoneHint:
      'Ваш текущий часовой пояс {{timeZone}}. Если вы планируете рассылку в другом часовом поясе,\nвыберите его из списка ниже. Результаты рассылки будут отображаться в вашем часовом поясе',
    timePeriod: 'Период, в течение которого рассылка будет доставляться получателям',
    timePeriodHint: 'Часы в течение дня, в которые разрешено отправлять рассылку',
    timePeriodOff: 'Не устанавливать',
    timePeriodOn: 'Установить свой диапазон, не учитывать местное время получателей',
    timePeriodOnHint:
      'Мы отправим рассылку в указанном диапазоне согласно настройке часового пояса в профиле {{timeZone}}',
    timePeriodOnWithTimezoneHint:
      'Мы отправим рассылку в указанном диапазоне согласно настройке часового пояса рассылки {{timeZone}}',
    timePeriodOnByLocal: 'Установить свой диапазон и учитывать местное время получателей',
    timePeriodOnByLocalHint:
      'Если мы не сможем определить местное время получателя, то отправим рассылку в указанном диапазоне согласно настройке\nчасового пояса в профиле {{timeZone}}',
    timePeriodOnByLocalWithTimezoneHint:
      'Если мы не сможем определить местное время получателя, то отправим рассылку в указанном диапазоне согласно настройке\nчасового пояса рассылки {{timeZone}}',
    messageSpeed: 'Скорость отправки сообщений в рассылке',
    flowIntegration: 'Интеграция с триггерными цепочками',
    flowIntegrationHint:
      'Включите, если какая-либо из ваших триггерных цепочек реагирует на или инициируется исходящим сообщением',
    comment: 'Дополнительная информация о рассылке',
    commentHint:
      'Комментарий или метаинформация о рассылке (необязательно). Указанный комментарий будет\nпередан через вебхук об изменении статуса сообщения. Можно использовать любые символы и\nпеременные',
  },
  contentForm: {
    ABTestButton: 'Запустить А/В-тест рассылки',
    ABTestModal: {
      thankYou: 'Спасибо за интерес!',
      infoText:
        'Мы работаем над возможностью создания A/B-тестов в рассылках и сообщим, когда функция станет доступна. Хотите узнать в первых рядах?',
      infoButton: 'Узнать о запуске',
      emailLabel: 'Оставьте ваш email и мы пришлем вам обновление',
      successText: 'Мы записали ваш email, до связи!',
      send: 'Отправить',
    },
    title: 'Отправить сообщение',
    licenseWarning: 'Чтобы создавать рассылки, необходимо оплатить лицензию канала',
    messageContent: 'Содержание сообщения',
    subjectContent: 'В одном канале',
    cascadeContent: 'В каскадной рассылке',
    selectCascade: 'Выберите или создайте каскад для рассылки',
    selectCascadeHint: 'Доступны к выбору каскады, состоящие из каналов с активными лицензиями',
    cascade: 'каскад',
    selectSubject: 'Выберите канал для отправки',
    selectSubjectHint: 'Для рассылки доступны только каналы с активной лицензией',
    contentTitle: 'Содержание сообщений в каналах',
    sender: 'Отправитель',
    selectTemplate: 'Выберите шаблон рассылки',
    attachDocumentLabel: 'Прикрепите файл',
    attachImageLabel: 'Прикрепите изображение',
    attachDocument: 'Прикрепить файл',
    attachAnotherDocument: 'Прикрепить другой файл',
    ttl: `через {{hours}}{{minutes}}{{seconds}}
      тем, кто не получил сообщение`,
    time: {
      seconds_one: 'секунду',
      seconds_few: 'секунды',
      seconds_many: 'секунд',
      minutes_one: 'минуту',
      minutes_few: 'минуты',
      minutes_many: 'минут',
      hours_one: 'час',
      hours_few: 'часа',
      hours_many: 'часов',
    },
  },
  cascadeModal: {
    name: 'Название каскада',
    steps: 'Шаги каскада',
    create: 'Создать каскад',
  },
  noCascades: {
    title: 'Время создать каскад',
    content:
      'Чтобы повысить уровень доставки сообщений, нужно создать правило последовательности отправки сообщений - каскад. Если сообщение не доставлено получателю в течение установленного времени, мы отправим ему сообщение на следующем шаге каскада.',
  },
  smsForm: {
    findMatch: 'Проверить на соответствие шаблону',
    templateMatch: {
      found: 'Шаблон зарегистрирован.',
      foundHint:
        'Введенный текст соответствует зарегистрированному шаблону. Тарификация дешевле у следующих операторов:',
      foundPartial: 'Шаблон частично зарегистрирован.',
      foundPartialHint:
        'Сообщения, не соответствующие шаблону, тарифицируются следующими операторами как рекламные:',
      notFound: 'Шаблон не найден в системе.',
      notFoundHint:
        'Сообщения, не соответствующие шаблону, тарифицируются операторами как рекламные.',
      otherHint:
        'У остальных операторов сообщения не соответствуют шаблону и тарифицируются как рекламные',
    },
    phoneNumberHint:
      'Если вы попробуете отправить рассылку на номера разных операторов, вы сможете посмотреть стоимость сообщений в итоговом отчете. Рассылка платная.',
    text: 'Текст сообщения',
    textHint:
      'Подставьте переменные или текст на месте строки символов.\n' +
      'Например, вы можете обратиться к получателю сообщения по имени, указав в тексте сообщения тег {имя} или {name}: «Добрый день, {имя}! Приятного дня». Если для получателя заполнена эта переменная, edna Pulse отправит сообщение вида «Добрый день, Юлия! Приятного дня», а если переменная не заполнена — сообщение вида «Добрый день, ! Приятного дня»',
    operatorsApproved:
      'Сообщения для активного операторского шаблона стоят дешевле. Шаблон активен у следующих операторов:',
    operatorsPending:
      'После регистрации операторского шаблона тарификация дешевле у следующих операторов (до регистрации сообщения тарифицируются как рекламные):',
    operatorsRejected:
      'После отклонения операторского шаблона сообщения тарифицируются как рекламные. Шаблон отклонен у следующих операторов:',
  },
  testForm: {
    recipient: 'Протестировать рассылку',
    recipientPlaceholder: 'Добавить номер для тестирования',
    sendTest: 'Отправить тест',
    sendMessage: 'Отправить сообщение',
    byPhone: 'на номер: {{phone}}',
    pushRecipient: 'Протестировать пуш',
    pushRecipientHint: 'Выберите получателей для тестирования и отправьте пуш-уведомления',
    sendPushTest: 'Отправить тестовый пуш',
  },
  viberForm: {
    text: 'Текст сообщения',
    textHint:
      'Подставьте переменные или текст на месте строки символов.\n' +
      'Например, вы можете обратиться к получателю сообщения по имени, указав в тексте сообщения тег {имя} или {name}: «Добрый день, {имя}! Приятного дня». Если для получателя заполнена эта переменная, edna Pulse отправит сообщение вида «Добрый день, Юлия! Приятного дня», а если переменная не заполнена — сообщение вида «Добрый день, ! Приятного дня»',
    type: 'Выберите тип сообщения',
    imageLabel: 'Изображение в формате JPEG, JPG, PNG размером 400x400 px, до 25 МБ',
    buttonLabel: 'Название кнопки',
    buttonLinkLabel: 'Ссылка кнопки',
    shouldCollectClicks: 'Отслеживать переходы по кнопкам-ссылкам',
    shouldCollectClicksHint: 'Ссылка в сообщении заменяется индивидуально для каждого получателя',
    optional: ' (необязательно)',
  },
  maxForm: {
    text: 'Текст сообщения',
    textHint:
      'Подставьте переменные или текст на месте строки символов.\n' +
      'Например, вы можете обратиться к получателю сообщения по имени, указав в тексте сообщения тег {имя} или {name}: «Добрый день, {имя}! Приятного дня». Если для получателя заполнена эта переменная, edna Pulse отправит сообщение вида «Добрый день, Юлия! Приятного дня», а если переменная не заполнена — сообщение вида «Добрый день, ! Приятного дня»',
    safeModeWarning:
      'Безопасный режим отправки: для снижения риска блокировки скорость отправки сообщений в этом канале автоматически ограничена.',
    addAttachment: 'Добавить вложение',
    attachment: {
      [EContentType.IMAGE]: {
        label: 'Изображение',
        urlLabel: 'Вставить изображение',
        urlHint: 'URL изображения',
      },
      [EContentType.VIDEO]: {
        label: 'Видео',
        urlLabel: 'Вставить видео',
        urlHint: 'URL видео',
      },
      [EContentType.DOCUMENT]: {
        label: 'Файл',
        urlLabel: 'Вставить файл',
        urlHint: 'URL файла',
      },
    },
  },
  notifyForm: {
    messageMatcherId: 'Название шаблона',
    buttonTypes: {
      [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
    },
    button: {
      dynamicLinkMessage:
        'В этом шаблоне нужно вручную ввести динамическую часть ссылки вашей кнопки (дописать недостающую часть ссылки и/или вставить переменную)',
      text: 'Текст',
      staticUrl: 'Ссылка кнопки (статическая часть ссылки)',
      dynamicUrl: 'Динамическая часть ссылки',
      dynamicUrlHint:
        'Для динамической части ссылки укажите ее значение без символа "/". Пример: <b>action234</b>. Чтобы сделать ссылку уникальной используйте переменные. Переменные добавляются <b>строго</b> в конец ссылки.',
    },
  },
  whatsAppForm: {
    text: 'Текст сообщения',
    textHint:
      'Подставьте переменные или текст на месте строки символов.\n' +
      'Например, вы можете обратиться к получателю сообщения по имени, указав в тексте сообщения тег {имя} или {name}: «Добрый день, {имя}! Приятного дня». Если для получателя заполнена эта переменная, edna Pulse отправит сообщение вида «Добрый день, Юлия! Приятного дня», а если переменная не заполнена — сообщение может быть не доставлено',
    imageUrlHint:
      'Поддерживаемые форматы изображений: JPEG, PNG. Максимальный размер изображения -1600x1200px, до 2Мб',
    documentUrlHint:
      'Поддерживаемые форматы вложений: текстовые файлы, PDF, Excel (.xls и .xlsx). Максимальный размер файла - 100 МБ',
    videoUrlHint: 'Поддерживаемые форматы видеофайлов (MP4). Максимальный размер файла - 16 МБ',
    buttonFields: {
      textLabel: 'Текст',
      urlLabel: 'Ссылка',
      urlHint: 'Разрешено использовать только https ссылки',
      payloadLabel: 'Код',
      payloadHint: 'Используйте этот код, чтобы отслеживать нажатие кнопок через API',
      phoneLabel: 'Номер телефона',
      staticUrlLabel: 'Ссылка кнопки (статическая часть ссылки)',
      collectClicksLabel: 'Отслеживаются переходы по кнопке',
      dynamicUrlLabel: 'Динамическая часть ссылки',
      dynamicUrlHint:
        'Для динамической части ссылки укажите ее значение без символа "/". Пример: <b>action234</b>. Чтобы сделать ссылку уникальной используйте переменные. Переменные добавляются <b>строго</b> в конец ссылки.',
    },
    buttonTypes: {
      [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
    },
    message:
      'В этом шаблоне нужно вручную ввести динамическую часть ссылки вашей кнопки (дописать недостающую часть ссылки и/или вставить переменную)',
    banners: {
      qualityWarning:
        'На канал <0></0><1>{{name}}</1> поступило много жалоб, есть риск понижения лимитов.',
      qualityRestricted: `Рассылка может не уйти! Для канала <0></0><1>{{name}}</1> был исчерпан суточный лимит исходящих сообщений.
    <br/>Некоторые сообщения могут быть не доставлены.`,
      messagingLimit: 'Суточный лимит: <0>{{limit}}</0>{{messages}}',
      qualityInfo: `Суточный лимит канала <0></0><1>{{name}} - {{limit}}</1>{{messages}}.`,
      planningComment: '<br/>Учитывайте это при планировании рассылки',
      mauInfo: `Сейчас остаток MAU по вашему тарифу <0>{{mauCount}}</0> из {{mauTotal}}.`,
      amauInfo: `<br/>Использовано <0>{{amauCount}}</0> AMAU`,
      messages: ' сообщений',
      wabaRestriction:
        'Бизнес-аккаунт WhatsApp {{wabaId}}, к которому относится <0></0><1>{{name}}</1>, ограничен из-за нарушения правил или политики использования WhatsApp. {{reason}}<b>Отправка исходящих сообщений невозможна до {{expirationDate}}</b>. <br/>Канал доступен только для приема входящих сообщений.',
      wabaRestrictionReason: 'Причина — {{violationType}}. ',
      wabaDisabled:
        'Бизнес-аккаунт WhatsApp {{wabaId}}, к которому относится <0></0><1>{{name}}</1>, отключен из-за нарушения правил или политики использования WhatsApp. Работа канала остановлена.',
      more: 'Подробнее',
      MMApiWarning:
        '<0>Ваши маркетинговые сообщения сейчас дороже:</0> вы ещё не приняли условия использования Marketing Messages API (MM API) <1>Как принять</1> <2></2>',
    },
    useMarketingMessagesApi: 'Отправить шаблонное сообщение через MM API',
    useMarketingMessagesApiHint:
      'MM API подходит для работы с новой или менее вовлечённой аудиторией. Этот метод повышает доставляемость, помогает эффективнее использовать бюджет и снижает риск блокировки канала',
    useCloudApiHint: 'Сообщения отправляются более дорогим способом – Cloud API',
    messageActivitySharing: 'Разрешать использовать текст переписки для оптимизации',
    messageActivitySharingHint: 'Оптимизация сообщений недоступна',
    cloudApiPromptModal: {
      title: 'Вы хотите отправить рассылку через Cloud API?',
      subtitle:
        'Как способ отправки Cloud API дороже, меньше подходит для работы с новой или менее вовлечённой аудиторией, имеет более высокие риски блокировки канала чем MM API.',
      submitButton: 'Выбрать Cloud API',
    },
  },
  pushForm: {
    header: 'Заголовок сообщения',
    headerHint:
      'Заголовок отображается на устройстве в одну строку. Максимальная длина примерно равна 50 символам (ограничения Андроид)',
    text: 'Введите текст рассылки и переменные',
    textHint:
      'Вы можете обратиться к получателю сообщения по имени, указав в тексте сообщения тег {имя} или {name}. Например, «Добрый день, {имя}! Приятного дня». Если в списке получателей будет заполнено имя, то SMS будет вида «Добрый день, Юлия! Приятного дня». Если имя не будет заполнено, то тег будет пропущен.',
    pushImages: 'Изображения в пуше',
    pushHeaderImage: 'Иконка в пуше',
    pushHeaderImageHint:
      'Иконка (логотип) для отображения в свернутом пуше. Рекомендуемое соотношение сторон 1x1, размер не более 1024x1024',
    pushImage: 'Большое изображение в пуше',
    pushImageHint:
      'Большое изображение для развернутого пуша. Рекомендуются изображения с соотношениями сторон 2x1, где основная визуальная масса остается при обрезке до 1.79x1 и 2,5x1 (ограничения Андроид)',
    buttonsAndActions: 'Кнопки и действия',
    additionalParameters: 'Дополнительные параметры',
    key: 'Ключ',
    value: 'Значение',
    addParameter: ' параметр',
    addPushAction: 'Добавить ссылку на нажатие по пушу',
    pushAction: 'Ссылка пуша',
    pushActionHint: 'Ссылка, которая передается в приложение при переходе получателя по пушу',
  },
  checkForm: {
    title: 'Проверьте данные рассылки перед отправкой',
    name: 'Название рассылки',
    startDateAndTime: 'Дата и время отправки',
    sendSettings: 'Настройки отправки',
    unknown: 'Неизвестно',
    notSet: 'Не установлено',
    date: 'Дата',
    time: 'Время',
    startNow: 'Отправить сразу',
    broadcastDuration: 'Продолжительность рассылки',
    timePeriod: 'Время доставки сообщений получателям',
    countingRecipients: 'Рассчитывается...',
    numberOfRecipients: 'Количество получателей',
    uploadSubscribers: 'Аудитория еще загружается. <0>Посмотреть прогресс</0>',
    includedRecipients: 'Включенные получатели',
    excludedRecipients: 'Исключенные получатели',
    messageSpeed: 'Интервал отправки сообщений',
    previewTitle: 'Вид сообщения',
    buttonLink: 'Ссылка кнопки',
    cascade: 'Каскад рассылки',
    additionalInfo: 'Дополнительная информация',
    comment: 'Комментарий, мета-информация',
    whatsAppMau: {
      calculateMau: 'Проверить MAU',
      calculatingMau: 'Проверяем количество MAU',
      calculatingAudience: 'Проверяем аудиторию рассылки',
      mauValue: '{{count}} MAU',
      amauValue: '{{count}} AMAU',
      and: ' и ',
      info:
        'Рассылка на выбранную аудиторию использует <0></0> из тарифа.' +
        '<br/><br/>Текущий остаток MAU по тарифу – <1>{{remainingCount}} MAU.</1>',
      hint:
        '*MAU (Monthly Active Users) — количество уникальных получателей, взаимодействовавших с вами в текущем месяце.' +
        '<br/><br/>*AMAU (Additional Monthly Active Users) — количество уникальных получателей, взаимодействовавших с вами в текущем месяце сверх лимита тарифа.',
    },
  },
  audienceForm: {
    [EAudienceGroupState.included]: 'Включить получателей с тегами',
    [EAudienceGroupState.excluded]: 'Исключить получателей с тегами',
    subscribers: 'получателей',
    tags: 'Доступные теги',
    tagsSearch: 'Поиск по тегам',
    emptyTags: {
      [EAudienceGroupState.included]: 'Добавьте теги включенной аудитории',
      [EAudienceGroupState.excluded]: 'Добавьте теги исключенной аудитории',
    },
    excludeUnsubscribed: 'Исключить получателей, которые отписались от рассылок',
    excludeUnsubscribedHint:
      'Настройка действует только для каналов WhatsApp. Если получатель ранее нажимал на кнопку отписки в конкретном канале WhatsApp, то ему рассылка в этом канале не будет отправлена.',
    group: 'Группа',
    addGroup: 'Добавить еще группу',
    groupOperator: 'Оператор внутри группы',
    groupsOperator: 'Оператор между группами',
    uploadSubtitle:
      'Загружаем и обновляем вашу аудиторию, это займет какое-то время.\n' +
      'Вы можете покинуть страницу — процесс будет выполняться. \n' +
      'Актуальный статус загрузки можно узнать на <0>этой странице</0>',
  },
  sendConfirmation: {
    title: 'Отправляем рассылку?',
    message: 'Все проверено и все готово, можно отправлять!',
  },
  planingConfirmation: {
    title: 'Планируем рассылку?',
    message: 'Все проверено и все готово, дальше рассылка отправится сама в нужное время!',
  },
  countdown: {
    title: 'Отправляем рассылку',
    message1: 'Рассылка отправится через 5 секунд.',
    message2:
      'У вас есть 5 секунд, чтобы передумать и поправить, прежде чем рассылка уйдет получателям',
  },
  sentAlert: {
    title: 'Ваша рассылка отправлена!',
    message1: 'Рассылка будет доставляться получателям в течение {{value}}',
    message2: 'Статус рассылки и данные по ней смотрите в карточке рассылки',
  },
  returnToDraftsConfirm: {
    title: 'Вернуть рассылку в черновики?',
    message:
      'Если вы нажмете "да", то эта запланированная рассылка перейдет в статус "Черновик", и, соответственно, не будет отправлена',
  },
  selectTemplate: {
    title: 'Использовать шаблон',
  },
  plannedAlert: {
    title: 'Ваша рассылка запланирована!',
    message1: 'Рассылка начнёт доставляться получателям в указанные день и время',
    message2: 'Статус рассылки и данные по ней смотрите в карточке рассылки',
  },
  plannedError: {
    title: 'Ошибка при планировании рассылки',
    message: `При проверке данных рассылки мы обнаружили ошибку, которая не дает запланировать рассылку.<br/>Скопируйте код возникшей ошибки и передайте в службу поддержки:`,
    copyErrorCode: 'Скопировать код ошибки',
  },
  loadingAudienceModal: {
    title: 'Аудитория рассылки еще не загружена',
    subtitle: 'Рассылку можно будет отправить, когда весь список аудитории будет загружен',
  },
  notification: {
    testSentSuccess: 'Тестовое сообщение успешно отправлено',
    returnToDraftsSuccess: 'Рассылка возвращена в черновики',
  },
  error: {
    failedToTest: 'Извините, не удалось протестировать рассылку.',
    failedToCancel: 'Извините, не удалось отменить рассылку.',
  },
  and: 'И',
  or: 'Или',
  invalidDateAndTime: 'Проверьте дату и время отправки рассылки',
  invalidMessageSpeed: 'Проверьте интервал отправки сообщений',
  hasInvalidRecipients: 'В аудитории есть ошибка. Рассылку никто не получит',
  invalidContent: 'В содержании рассылки для выделенного канала есть ошибка',
  invalidEmptyCascade: 'Каскад не выбран',
  startsNow: 'Сразу после подтверждения отправки',
  template: 'Шаблон',
  balanceProblem: {
    title: 'Вы не можете отправить рассылку',
    message1:
      'Сейчас средств на вашем счету недостаточно для отправки рассылки. Чтобы снова отправлять рассылки вам нужно пополнить баланс. Не волнуйтесь, мы в любом случае сохраним эту рассылку как черновик',
    message2:
      'Сейчас размера вашего овердрафта недостаточно для отправки рассылки. Чтобы решить вопрос с вашим балансом и снова отправлять рассылки, свяжитесь с вашим менеджером. Мы в любом случае сохраним эту рассылку как черновик',
    topUp: 'Пополнить баланс',
    writeManager: 'Написать менеджеру',
  },
  filters: {
    searchPlaceholder: 'Быстрый поиск по названию рассылки',
    broadcastStartedDate: 'Дата запуска рассылки',
    broadcastStatus: 'Статус рассылки',
    channelType: 'Канал',
    broadcastName: 'Название рассылки',
    initiatorName: 'Инициатор рассылки',
    cascadeName: 'Название каскада',
    channelName: 'Название канала',
    subscribersTags: 'Теги получателей рассылки',
    selectTags: 'Выбрать теги',
    comment: 'Комментарий (мета-информация) о рассылке',
    trafficType: 'Тип трафика',
    commentFilled: 'Заполнен',
    trafficHint:
      'Рекламный и сервисный типы трафика соответствуют шаблону, который использовался в рассылке',
    commentHint:
      'Указанный комментарий будет передан через вебхук об изменении статуса сообщения. Можно использовать любые символы и переменные',
    broadcasts: 'Рассылок',
  },
};
